import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  logo: {
    width: 124,
    height: 26,
  },
});
